module.exports = __webpack_public_path__ + "img/jellybean_malibu.2b5f50ae.png";